import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-add,delivery"><path d="M12.25 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V11.25M18.25 14.25V17.25M18.25 17.25V20.25M18.25 17.25H15.25M18.25 17.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageAdd;
